export default "__VITE_ASSET__ANdZYVko__"